<app-dialog-base [Title]='"Notification"|translate' [dialogId]="dialogId" (onClose)="close()"
                 (onSubmit)="submit()" [isSubmitDisabled]="isLoading" [isLoading]="isLoading">
  <div class="btn_tabs">
    <button (click)="openTab('main')" [class.active]="openedTabName == 'main'">{{"Main"|translate}}</button>
    <button (click)="openTab('limits')" [class.active]="openedTabName == 'limits'">{{"Limits"|translate}}</button>
    <button (click)="openTab('objects')" [class.active]="openedTabName == 'objects'">{{"Objects"|translate}}</button>
    <button (click)="openTab('notification')" [class.active]="openedTabName == 'notification'">{{"Notification"|translate}}</button>
  </div>

  <div class="horseparator"></div>
  <div id="main" *ngIf="isSelected('main')" class="tablewrap">
      <div class="table">
          <div class="inputgroup">
              <label>{{'Name'|translate}}</label>
              <input type="text" placeholder="{{'Name'|translate}}" [(ngModel)]="model.Name" />
          </div>
          <div class="inputgroup" *ngIf="containers.length">
              <label>{{'Container'|translate}}</label>
              <input *ngIf="isEditMode" type="text" [value]="getSelectedContainerName()" readonly />
              <select *ngIf="!isEditMode" [(ngModel)]="model.ContainerId" (ngModelChange)="onContainerChanged()">
                  <option *ngFor="let container of containers" [ngValue]="container.Id">{{container.Name}}</option>
              </select>
          </div>
          <div class="inputgroup">
              <label>{{'Text template'|translate}}</label>
              <input type="text" placeholder="{{'Text template'|translate}}" [(ngModel)]="model.TextTemplate" />
          </div>
          <div class="inputgroup">
              <label>{{'Type'|translate}}</label>
              <select title="{{'Type'|translate}}" (change)="onTypeChange($event)">
                  <option value="SPEED" [selected]="model.EventType == 'SPEED'">{{'Speed'|translate}}</option>
                  <option value="NO_DATA" [selected]="model.EventType == 'NO_DATA'">{{'No data'|translate}}</option>
                  <option value="OLDCURPOS" [selected]="model.EventType == 'OLDCURPOS'">{{'No connection to satellite'|translate}}</option>

                  <option value="PARK" [selected]="model.EventType == 'PARK'">{{'Parking'|translate}}</option>
                  <option value="MOVE" [selected]="model.EventType == 'MOVE'">{{'Movement'|translate}}</option>
                  <option value="IDLING" [selected]="model.EventType == 'IDLING'">{{'Idling'|translate}}</option>

                  <option value="TREND_VALUE" [selected]="model.EventType == 'TREND_VALUE'">{{'Sensor value'|translate}}</option>
                  <option value="TREND_OUT_OF_SCALE" [selected]="model.EventType == 'TREND_OUT_OF_SCALE'">{{'Sensor value out of scale'|translate}}</option>

                  <option value="EXITZONE" [selected]="model.EventType == 'EXITZONE'">{{'Leave geozone'|translate}}</option>
                  <option value="ENTERZONE" [selected]="model.EventType == 'ENTERZONE'">{{'Enter in geozone'|translate}}</option>

                  <option value="PHOTO" [selected]="model.EventType == 'PHOTO'">{{'Receiving photos'|translate}}</option>
                  <option value="FUEL_FILLING" [selected]="model.EventType == 'FUEL_FILLING'">{{'Refueling'|translate}}</option>
                  <option value="FUEL_DRAIN" [selected]="model.EventType == 'FUEL_DRAIN'">{{'Fuel drain'|translate}}</option>
              </select>
          </div>
          <div class="inputgroup">
              <label>{{'Disabled'|translate}}</label>
              <input type="checkbox" [(ngModel)]="model.Disabled" />
          </div>
          <div class="inputgroup">
            <label>{{'Notify operator'|translate}}</label>
            <input type="checkbox" [(ngModel)]="model.NotifyOperator" />
          </div>
          <div class="inputgroup" *ngIf="model.EventType == 'TREND_VALUE'">
              <label>{{'Sensor name'|translate}}</label>
              <input type="text" placeholder="{{'Sensor name'|translate}}" [(ngModel)]="model.TrendName" />
          </div>
          <div class="inputgroup" *ngIf="hasPermittedInterval()">
              <label>{{'Permitted interval'|translate}}</label>
              <div class="grid11">
                  <div class="inputgroup grid18">
                      <label>{{'From'|translate}}</label>
                      <input type="number" [(ngModel)]="model.MinValue" />
                  </div>
                  <div class="inputgroup grid18">
                      <label>{{'To'|translate}}</label>
                      <input type="number" [(ngModel)]="model.MaxValue" />
                  </div>
              </div>
          </div>
          <div class="inputgroup" *ngIf="hasDuration()">
              <label>{{'Min. duration'|translate}}</label>
              <label><input type="number" placeholder="0" [ngModel]="model.MinDuration | localizeSeconds" (ngModelChange)="convertMinDurationPeriod($event)" /><span>{{'sec'|translate}}</span></label>
          </div>
          <div class="inputgroup" *ngIf="hasDuration()">
              <label>{{'Min. delay between events'|translate}}</label>
              <label><input type="number" placeholder="0" [ngModel]="model.MinDelayBetween | localizeSeconds" (ngModelChange)="convertMinDelayBetween($event)" /><span>{{'sec'|translate}}</span></label>
          </div>
          <div class="inputgroup" *ngIf="hasDuration()">
              <label>{{'Repeat'|translate}}</label>
              <label><input type="number" placeholder="0" [ngModel]="model.RepeatPeriod | localizeHours" (ngModelChange)="convertRepeatPeriod($event)" /><span>{{'hours'|translate}}</span></label>
          </div>
          <app-base-group-mgmt-component [Title]="'Groups'" [Objects]="model.Groups" [groups]="filteredGroups" style="z-index: 1;">
              <ng-template let-item>
                  <td>{{item.Name}}</td>
              </ng-template>
          </app-base-group-mgmt-component>
      </div>
  </div>
  <div id="limits" *ngIf="isSelected('limits')" class="tablewrap modal-events-table">
    <div class="table">
      <div class="inputgroup">
        <label>{{'Work days'|translate}}</label>
        <div class="workdays">
          <app-week-day-selector [(mask)]="model.Mask"></app-week-day-selector>
        </div>
      </div>
      <div class="inputgroup">
        <label>{{'Time'|translate}}</label>
        <div class="grid11">
          <div class="inputgroup grid18">
            <label>{{'from'|translate}}</label>
            <input type="time" placeholder="{{'from'|translate}}" [(ngModel)]="model.From" step="60" min="00:00" max="23:59" />
          </div>
          <div class="inputgroup grid18">
            <label>{{'till'|translate}}</label>
            <input type="time" placeholder="{{'till'|translate}}" [(ngModel)]="model.Till" step="60" min="00:00" max="23:59" />
          </div>
        </div>
      </div>

      <div class="inputgroup">
        <label>{{'In geozones'|translate}}</label>
        <label >
          <input style="padding-right:20px;" type="text" placeholder="{{'Select geozones'|translate}}" [value]="getGeozonesDescription(model.InGeozones)" (click)="selectGeozones(model.InGeozones)" />
          <span class="relative-span">
            <button class="btn_img btn_trush" *ngIf="model.InGeozones.length" (click)="CleanInGeozones($event)" title="{{'Clear'|translate}}"></button>
          </span>
        </label>
      </div>
      <div *ngIf="model.EventType !== 'ENTERZONE' && model.EventType !== 'EXITZONE'" class="inputgroup">
        <label>{{'Out of geozones'|translate}}</label>
        <label>
          <input type="text" placeholder="{{'Select geozones'|translate}}" [value]="getGeozonesDescription(model.OutOfGeozones)" (click)="selectGeozones(model.OutOfGeozones)" />
          <span>
            <button class="btn_img btn_trush" *ngIf="model.OutOfGeozones.length" (click)="CleanOutGeozones($event)" title="{{'Clear'|translate}}"></button>
          </span>
        </label>
      </div>
    </div>
  </div>
  <div id="objects" *ngIf="isSelected('objects')" class="tablewrap">

    <app-base-group-mgmt-component [Title]="'Objects'" [Objects]="model.TrackerIds" [groups]="allObjects" style="z-index: 1;" [groupsUsedForObjectsSelection]="objectGroups">
      <ng-template let-item>
        <td>{{item.Name}}</td>
      </ng-template>
    </app-base-group-mgmt-component>

  </div>

  <div id="notification" *ngIf="isSelected('notification')" class="tablewrap">
    <div class="table">
      <div class="inputgroup">
        <label>{{'Email'|translate}}</label>
        <input type="email" placeholder="{{'Email'|translate}}" [(ngModel)]="model.Email" />
      </div>
      <div class="inputgroup" *ngIf="false">
        <label>{{'Phone №'|translate}}</label>
        <input type="text" placeholder="{{'Phone №'|translate}}" [(ngModel)]="model.Phone" />
      </div>
      <div class="inputgroup">
        <label>{{'Telegram id'|translate}}</label>
        <input type="text" placeholder="{{'Telegram id'|translate}}" [(ngModel)]="model.Phone" />
      </div>
      <div class="inputgroup">
        <label>{{'Http request'|translate}}</label>
        <input type="text" placeholder="http://" [(ngModel)]="model.HttpRequest" />
      </div>
      <div class="inputgroup">
        <label>{{'On activating command'|translate}}</label>
        <select title="{{'Command'|translate}}" [(ngModel)]="model.StartCommandId">
          <option value="0" [selected]="model.StartCommandId == 0">{{'None'|translate}}</option>
          <option *ngFor="let command of commands" value="{{command.Id}}"
                  [selected]="model.StartCommandId === command.Id">
            {{command.Name}}
          </option>
        </select>
      </div>
      <div class="inputgroup">
        <label>{{'On deactivating command'|translate}}</label>
        <select title="{{'Command'|translate}}" [(ngModel)]="model.StopCommandId">
          <option value="0" [selected]="model.StopCommandId == 0">{{'None'|translate}}</option>
          <option *ngFor="let command of commands" value="{{command.Id}}"
                  [selected]="model.StopCommandId === command.Id">
            {{command.Name}}
          </option>
        </select>
      </div>
    </div>
  </div>
</app-dialog-base>

<template #objectsListDialog></template>
